
import React, { createContext, useContext } from 'react';
import { createTheme } from '@mui/material/styles';
import MuiThemeProvider from "@mui/material/styles/ThemeProvider";
import { red } from '@mui/material/colors';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import { MaterialUIControllerProvider } from "../themes/mui/context";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 PRO React TS themes
import themeLight from "../themes/mui/assets/theme";
import themeRTL from "../themes/mui/assets/theme/theme-rtl";

// Material Dashboard 2 PRO React TS Dark Mode themes
import themeDark from "../themes/mui/assets/theme-dark";
import themeDarkRTL from "../themes/mui/assets/theme-dark/theme-rtl";

// Material Dashboard 2 PRO React TS contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "../themes/mui/context";
import "../themes/mui/assets/scss/styles.scss";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    jsforce: any,
    baseUrl: string
}

const ThemeContext = createContext(null);

const CustomMuiThemeProvider = ({children}) => {
    const [controller, dispatch] = useMaterialUIController();
    const {
        miniSidenav,
        direction,
        layout,
        openConfigurator,
        sidenavColor,
        transparentSidenav,
        whiteSidenav,
        darkMode,
    } = controller;
    return (
        <MuiThemeProvider theme={darkMode ? themeDark : themeLight}>
            <CssBaseline />
            {children}
        </MuiThemeProvider>
    )
};

const useThemeProvider = () => {
    const context = useContext(ThemeContext);
    return context;
};

function getSFResourcesPath(){
    if(process.env.NODE_ENV === "development"){
        return "";
    }
    if(typeof(window.inlineApexAdaptor) === "undefined" || typeof(window.inlineApexAdaptor.resources) === "undefined"){
        return null;
    }
    return window.inlineApexAdaptor.resources;
}

function getCdnUrl(){
    let cdn = "";
    if(window.inlineApexAdaptor && window.inlineApexAdaptor.landingResources){
        cdn = window.inlineApexAdaptor.landingResources;
        cdn = cdn.replace(/\/+$/, '');; //Remove trailing slash
        cdn += "/";
    }
    return cdn;
}

const ThemeProvider = ({children, theme}) => {
    
    if(theme === 'mui'){
        return (
            <ThemeContext.Provider value={theme}>
                {/* <MaterialUIControllerProvider> */}
                    <CustomMuiThemeProvider>
                        {children}
                    </CustomMuiThemeProvider>
                {/* </MaterialUIControllerProvider> */}
            </ThemeContext.Provider>
        )
    }
    return (
        <ThemeContext.Provider value={theme}>
            <IconSettings iconPath={getSFResourcesPath()+"/assets/icons"} >
                {children}
            </IconSettings>
        </ThemeContext.Provider>
    )
};

export { ThemeProvider, ThemeContext, useThemeProvider, getCdnUrl };